// Should stay in sync with the signalRMessageTargets.mjs

const MESSAGE_TARGETS = {
  APPRAISAL: 'appraisal',
  USER_SESSION_ENDED: 'user-session-ended',
  TOAST_NOTIFICATION: 'toast-notification',
  LEGAL_FILE_VALIDATION_NOTIFICATION: 'legal-file-validation-notification',
  DE_DUPLICATED_CHECKPOINT_FILE_VALIDATION_NOTIFICATION:
    'de-duplicated-checkpoint-file-validation-notification',
  OBSERVATION_REPORT_FILE_VALIDATION_NOTIFICATION: 'observation-report-file-validation-notification'
};

export default MESSAGE_TARGETS;
